import { formatCustomDate } from "helpers/dateTools";
import { orderArrayV2 } from "helpers/orderArray";
import { SUPERVISION_TYPES, SUPERVISION_TYPE_LABELS } from "helpers/supervisionTypes";

export const GET_SUPERVISED = "GET_SUPERVISED";
export const SET_SUPERVISED_FILTERS = "SET_SUPERVISED_FILTERS";
export const SAVE_TOKEN = "SAVE_TOKEN";

const INITIAL_STATE = {
  supervised: [],
  startDate: formatCustomDate(new Date(), "-"),
  endDate: formatCustomDate(new Date(), "-"),
  station: "",
  token: "",
};

const mapRecord = (record) => {
  const isManualNote = record.type === SUPERVISION_TYPES.MANUAL_NOTE;
  const hasDiscount = isManualNote
    ? (record.discount || 0) > 0
    : (record.notes || []).some(n => (n.note_details || []).some(d => (d.discount || 0) > 0));

  return {
    ...record,
    date: record.date?.split(".")[0] || "",
    typeLabel: SUPERVISION_TYPE_LABELS[record.type] || record.type,
    driver_name: record.driver_name || "",
    total_amount: isManualNote ? (record.total || 0) : (record.total_amount || 0),
    cash_amount: isManualNote ? null : (record.cash_amount || 0),
    services: isManualNote ? null : (record.services || 0),
    kilos: isManualNote ? (record.kgs || 0) : null,
    liters: isManualNote ? (record.lts || 0) : null,
    has_discount: hasDiscount,
    has_retention: isManualNote ? !!(record.retention) : false,
  };
};

export const supervisedReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_SUPERVISED: {
      const formatDates = Object.entries(payload?.liquidations).flatMap(([id, dateEntries]) =>
        Object.entries(dateEntries).flatMap(([_, records]) =>
          records.map(record => mapRecord({ ...record, id }))
        )
      );
      const order = orderArrayV2(formatDates, 'date', true);
      return {
        ...state,
        supervised: order,
      };
    }

    case SET_SUPERVISED_FILTERS: {
      let supervised = state.supervised;
      if (payload.key === 'station') supervised = [];
      return {
        ...state,
        [payload.key]: payload.data,
        supervised,
      };
    }

    case SAVE_TOKEN:
      return {
        ...state,
        token: payload?.token,
      };

    default:
      return state;
  }
};
